import { BreadcrumbsLinks } from '@interfaces/location';

import { ECP_HASH, EDC_HASH } from '@constants';
import { ROUTES } from '@constants/ROUTES';
import { ECP_APPS_URL } from '@constants/externalRoutes';

export const BREADCRUMBS_PAGE_TEXT = {
  ROOT: 'Postsecondary education and Training',
  SCHOOLS: 'Schools',
  SCHOOL_DETAILS: 'School details',
  FAVORITE_SCHOOLS: 'Favorite schools',
  MAJORS: 'Majors',
  MAJOR_DETAILS: 'Major details',
  FAVORITE_MAJORS: 'Favorite majors',
  SCHOOLS_BY_MAJOR: 'Schools by major',
  EDUCATION_PLANNER: 'Planning dashboard',
  EDUCATION_PLANNER_SCHOOLS: 'College applications',
  SCHOLARSHIPS: 'Scholarships',
  SCHOLARSHIP_DETAILS: 'Scholarship details',
  ADMIN_HOME_PAGE: 'My College',
  ECP_HOME_PAGE: 'Education and career planning',
  RECOMMENDER_WORKSPACE: 'Common App applicants',
  RECOMMENDER_PROFILE: 'Profile information',
  ORGANIZATION_DASHBOARD: 'Organization dashboard',
};

export const BREADCRUMBS_NAVIGATION_DATA: Record<string, BreadcrumbsLinks[]> = {
  [EDC_HASH]: [{ to: ROUTES.ROOT, text: BREADCRUMBS_PAGE_TEXT.ROOT }],
  [ECP_HASH]: [{ to: ECP_APPS_URL, text: BREADCRUMBS_PAGE_TEXT.ECP_HOME_PAGE }],
};
